var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#01684A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.24 10.0155L11.4464 16.1479C11.2276 16.3808 11.0159 16.8394 10.9736 17.157L10.7125 19.4434C10.6208 20.269 11.2135 20.8336 12.0321 20.6924L14.3044 20.3043C14.6219 20.2479 15.0665 20.015 15.2853 19.7751L21.0789 13.6427C22.081 12.5842 22.5326 11.3775 20.9731 9.90262C19.4206 8.44187 18.2421 8.95701 17.24 10.0155Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2734 11.0391C16.5769 12.9867 18.1576 14.4757 20.1194 14.6733",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H22.7022",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPhoto);
export default __webpack_public_path__ + "static/media/EditPhoto.564044d5fcc415279515d3b5c802d8d7.svg";
export { ForwardRef as ReactComponent };